
export default {
  props: {
    active: {
      type: Number,
      default: 8
    }
  },
  data() {
    return {}
  },
  methods: {}
}
